export enum ProductControls {
  ProductName = "product_name",
  CommonName = "common_name",
  Qty = "qty",
  MinSize = "min_size",
  MaxSize = "max_size",
  IsPromoted = "is_promoted",
  Tags = "tags",
  OriginCountryIso2 = "origin_iso2",
  VendorId = "vendor_id",
  CategoryId = "category_id",
  Status = "status",
  MoreDescription = "more_description",
  ProductImageUrl = "product_image",
  IsFeatured = "is_featured",
  IsRareFish = "is_exclusive",
  AvailableInBuildAquarium = "available_in_build_aquarium",
  SubcategoryId = "subcategory_id",
  SubsubcategoryId = "subsubcategory_id",
  IsPreOrder = "is_seasonal",
  IsRequestQuote = "is_request_quote",
  Temperament = "temperament",
  WaterCondition = "water_condition",
  Wysiwyg = "wysiwyg",
  ProductExpiry = "expires_at",
  ProductMedia = "productMedia",
  ProductOptions = "productOptions",
  CapacityInGallons = "capacity_in_gallons",
  TankLength = "tank_length",
  TankBreadth = "tank_breadth",
  TankHeight = "tank_height",
  CountrySpecificInfo = "countrySpecificInfo",
  AiTags = "ai_tags",
}

export enum ProductListingStatus {
  Active = "active",
  Inactive = "inactive",
  AuctionActive = "auction_active",
}
